import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, unref as _unref, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/premium-bg-white.svg'
import _imports_1 from '@/assets/icons/free-member-bg-white.svg'


const _withScopeId = n => (_pushScopeId("data-v-43f78dbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-w-full tw-h-full tw-flex tw-gap-2 tw-flex-col" }
const _hoisted_2 = { class: "tw-flex tw-flex-col tw-gap-1 tw-pb-3 tw-box-border tw-border-b-dashed-custom" }
const _hoisted_3 = { class: "tw-flex-row-between tw-gap-2 tw-flex-wrap" }
const _hoisted_4 = { class: "tag tw-rounded-full tw-flex tw-items-center tw-justify-center tw-w-[18px] tw-h-[18px]" }
const _hoisted_5 = {
  key: 0,
  class: "tw-w-[16px] tw-h-[16px] tw-object-contain",
  src: _imports_0
}
const _hoisted_6 = {
  key: 1,
  class: "tw-w-[16px] tw-h-[16px] tw-object-contain",
  src: _imports_1
}
const _hoisted_7 = {
  key: 0,
  class: "tw-text-[12px] tw-font-bold tw-text-[#8587A4] tw-leading-6 tw-whitespace-nowrap tw-border tw-border-solid tw-rounded-[6px] tw-border-[#0c0f4a8a] tw-px-1"
}
const _hoisted_8 = { class: "tw-flex tw-gap-2 tw-items-center" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "tw-w-full tw-h-full tw-flex tw-flex-col tw-items-start tw-gap-2" }
const _hoisted_11 = { class: "fixed-text tw-text-[18px] tw-font-semibold tw-text-[#0c0f4a]" }
const _hoisted_12 = { class: "tw-flex-row-between tw-gap-2 tw-flex-wrap" }
const _hoisted_13 = { class: "tw-flex tw-items-center tw-gap-1 tw-justify-between" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "tw-w-full" }
const _hoisted_16 = { class: "description" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = {
  key: 0,
  class: "card_stepper"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step__connector" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step__connector" }, null, -1))
const _hoisted_21 = { class: "tw-w-full tw-flex-row-between tw-mt-2" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "tw-rounded-full tw-w-[16px] tw-h-[16px] tw-flex tw-items-center tw-justify-center details-icon !tw-text-[10px]" }

import moment from "moment";
import { ref, onMounted, nextTick, computed, onUnmounted } from "vue";

import Text from "@/core/components/ui/general/Text.vue";
import ChipState from "@/core/components/common/ChipState.vue";

import EmergencyChip from "@/core/uni-components/Chips/EmergencyChip.vue";
import StandardChip from "@/core/uni-components/Chips/StandardChip.vue";
import RoutineChip from "@/core/uni-components/Chips/RoutineChip.vue";
import CommercialChip from "@/core/uni-components/Chips/CommercialChip.vue";
import ResidentialChip from "@/core/uni-components/Chips/ResidentialChip.vue";
import VideoConsultationChip from "@/core/uni-components/Chips/VideoConsultationChip.vue";
import DraftChip from "./chips/DraftChip.vue";
import NotStartedChip from "./chips/NotStartedChip.vue";
import CompletedChip from "./chips/CompletedChip.vue";
import RejectedChip from "@/modules/jobs/components/chips/RejectedChip.vue";
import InProgressChip from "./chips/InProgressChip.vue";
import EstimateSendChip from "./chips/EstimateSendChip.vue";
import EstimateAcceptedChip from "./chips/EstimateAcceptedChip.vue";

import {
  ProjectJobStatusEnum,
  PropertyCategoryEnum,
} from "@/core/enums/ProjectsEnum";
import { AgreeTermsConsumerDisclosure } from "@/core/enums/estimateEnum";


export default /*#__PURE__*/_defineComponent({
  __name: 'JobCard',
  props: {
  job: {
    type: Object,
    required: true,
  },
  jobType: {
    type: String,
  },
  hasProgressBar: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const descriptionElement = ref(null) as any;
const isOverflowing = ref(false);
const isDescriptionExpanded = ref(false);

const phaseCount = ref(0);
const phaseCompleted = ref(0);

const checkOverflow = () => {
  nextTick(() => {
    if (descriptionElement.value) {
      const el = descriptionElement.value;
      isOverflowing.value = el.scrollHeight > el.clientHeight;
    }
  });
};

// Method to calculate elapsed time
const calculateElapsedTime = (date: string): string => {
  const now = moment();
  const createdDate = moment(date);

  const total_seconds = now.diff(createdDate, "seconds");
  const total_minutes = now.diff(createdDate, "minutes");
  const total_hours = now.diff(createdDate, "hours");
  const days = now.diff(createdDate, "days");
  // const weeks = now.diff(createdDate, "weeks");
  // const months = now.diff(createdDate, "months");
  // const years = now.diff(createdDate, "years");

  // if (years > 0) {
  //   return `${years} Year${years > 1 ? "s" : ""}`;
  // } else if (months > 0) {
  //   return `${months} Month${months > 1 ? "s" : ""}`;
  // } else if (weeks > 0) {
  //   return `${weeks} Week${weeks > 1 ? "s" : ""}`;

  const hours = total_hours - days * 24; // Adjust hours based on full days
  const minutes = total_minutes - total_hours * 60; // Adjust minutes based on total hours
  const seconds = total_seconds - total_minutes * 60; // Adjust seconds based on total minutes

  let final_time = "";

  if (total_seconds > 0) {
    if (days > 0) {
      final_time += `${days} Day${days !== 1 ? "s" : ""} `;
    }
    if (hours > 0) {
      final_time += `${hours} Hr${hours !== 1 ? "s" : ""} `;
    }
    if (minutes > 0) {
      final_time += `${minutes} Min${minutes !== 1 ? "s" : ""} `;
    }
    if (seconds > 0) {
      final_time += `${seconds} Sec${seconds !== 1 ? "s" : ""}`;
    }
  }

  return final_time.trim(); // Trim any extra spaces
};

// Reactive reference to hold the elapsed time
// const elapsedTime = ref(calculateElapsedTime(props.job?.dateCreated));

// Update the elapsed time every minute
// const realTimeSetInterval = setInterval(() => {
//   elapsedTime.value = calculateElapsedTime(props.job?.dateCreated);
// }, 1000);

const getPropertyCategory = computed(() => ({
  isResidential: props.job?.properties?.length
    ? props.job.properties.some(
        (property: any) =>
          property?.propertyCategory === PropertyCategoryEnum.RESIDENTIAL
      )
    : false,
  isCommercial: props.job?.properties?.length
    ? props.job.properties.some(
        (property: any) =>
          property?.propertyCategory === PropertyCategoryEnum.COMMERCIAL
      )
    : false,
}));

const buttonText = computed(() =>
  isDescriptionExpanded.value ? "Read Less" : "Read More"
);
const toggleReadMore = () => {
  isDescriptionExpanded.value = !isDescriptionExpanded.value;
};
const stringWithoutTags = computed(() =>
  props.job?.description
    ? props.job?.description
        .trim()
        .replace(/<\/?[^>]+(>|$)/g, "")
        .replace(/\s\s+/g, " ")
    : " "
);

const projectDescription = computed(() => {
  return isDescriptionExpanded.value ||
    (stringWithoutTags.value && stringWithoutTags.value?.length <= 100)
    ? stringWithoutTags.value
    : stringWithoutTags.value?.substring(0, 100) + "...";
});

const projectAvgRating = computed(() => {
  const rating = props.job?.projectRating?.reduce(
    (previous: any, current: any) => {
      previous += current?.avgRating;
      return previous;
    },
    0
  );
  return rating / props.job?.projectRating?.length
    ? (rating / props.job?.projectRating?.length).toFixed(1)
    : 0;
});

const getProjectStatusElement = (project: any) => {
  if (!project.projectEstimation.length) {
    return {
      status: ProjectJobStatusEnum.DRAFT_PROJECT,
      component: NotStartedChip,
    };
  }
  const estimate = project.projectEstimation[0];
  const aggrement = [
    AgreeTermsConsumerDisclosure.ACCEPTED,
    AgreeTermsConsumerDisclosure.SECURE_PROJECT_ESCROW,
    AgreeTermsConsumerDisclosure.PROJECT_UNDERWAY,
    AgreeTermsConsumerDisclosure.COMPLETED,
  ].includes(estimate.agreeTermsConsumerDisclosure);
  if (
    [ProjectJobStatusEnum.IN_PROGRESS].includes(project.projectJobStatus?.id) &&
    aggrement
  ) {
    return {
      status: ProjectJobStatusEnum.IN_PROGRESS,
      component: InProgressChip,
    };
  } else if (
    [ProjectJobStatusEnum.QUOTES_RECEIVED].includes(
      project.projectJobStatus?.id
    ) &&
    aggrement
  ) {
    return {
      status: ProjectJobStatusEnum.QUOTES_RECEIVED,
      component: EstimateSendChip,
    };
  } else if (
    [ProjectJobStatusEnum.QUOTE_ACCEPTED].includes(
      project.projectJobStatus?.id
    ) &&
    aggrement
  ) {
    return {
      status: ProjectJobStatusEnum.QUOTE_ACCEPTED,
      component: EstimateAcceptedChip,
    };
  } else if (
    [ProjectJobStatusEnum.COMPLETED].includes(project.projectJobStatus?.id) &&
    aggrement
  ) {
    return {
      status: ProjectJobStatusEnum.COMPLETED,
      component: CompletedChip,
    };
  } else {
    return {
      status: ProjectJobStatusEnum.QUOTES_RECEIVED,
      component: EstimateSendChip,
    };
  }
};
onMounted(() => {
  checkOverflow();
  window.addEventListener("resize", checkOverflow);
  if (props.job?.projectEstimation?.length) {
    phaseCount.value = props.job?.projectEstimation[0]?.estimationPhase?.length;
    phaseCompleted.value =
      props.job?.projectEstimation[0]?.estimationPhase?.filter(
        (e: any) => e.phaseCompletionStatus
      )?.length;
  }
});
// onUnmounted(() => {
//   clearInterval(realTimeSetInterval);
// });

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_v_stepper_item = _resolveComponent("v-stepper-item")!
  const _component_v_stepper_header = _resolveComponent("v-stepper-header")!
  const _component_v_stepper = _resolveComponent("v-stepper")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: _normalizeClass(["tw-min-h-[250px] tw-bg-white tw-rounded-[20px] tw-shadow-none tw-cursor-pointer tw-p-4 tw-box-borders", 
      props.job?.userWorkstation?.subscription
        ? 'premium-job-gradient'
        : 'free-job-gradient'
    ]),
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => _ctx.$emit('onSelect', __props.job?.refId), ["prevent"]))
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(ChipState, {
              class: "tw-relative tw-z-10 !tw-justify-start !tw-p-[0] !tw-gap-2",
              hasCustomLabel: true,
              bgColor: "transparent",
              hasShadow: false
            }, {
              prefix: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  (props.job?.userWorkstation?.subscription)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                    : (_openBlock(), _createElementBlock("img", _hoisted_6))
                ])
              ]),
              "custom-label": _withCtx(() => [
                _createVNode(Text, {
                  variant: "span",
                  whiteSpace: "nowrap"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.job?.userWorkstation?.subscription ? "PREMIUM" : "FREE") + " ", 1),
                    _createVNode(Text, {
                      variant: "span",
                      whiteSpace: "nowrap",
                      textColor: "#FFA500"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("PROPERTY MEMBER")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (props.jobType === 'all')
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(props.job?.elapsedTime?.fullTime), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(Text, { variant: "span" }, {
              default: _withCtx(() => [
                _createTextVNode("Customer Rating: "),
                _createElementVNode("img", {
                  src: require('@/assets/icons/rating-star.svg')
                }, null, 8, _hoisted_9),
                _createVNode(Text, {
                  variant: "span",
                  textColor: "#8587A4"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(projectAvgRating.value), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("h5", _hoisted_11, _toDisplayString(__props.job?.name), 1),
          _createElementVNode("div", _hoisted_12, [
            (__props.job?.type === 'emergency')
              ? (_openBlock(), _createBlock(EmergencyChip, {
                  key: 0,
                  label: "Emergency"
                }))
              : _createCommentVNode("", true),
            (__props.job?.type === 'standard')
              ? (_openBlock(), _createBlock(StandardChip, { key: 1 }))
              : _createCommentVNode("", true),
            (__props.job?.type === 'routine')
              ? (_openBlock(), _createBlock(RoutineChip, { key: 2 }))
              : _createCommentVNode("", true),
            (__props.job?.type === 'video consultation')
              ? (_openBlock(), _createBlock(VideoConsultationChip, { key: 3 }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _createVNode(Text, {
                    variant: "span",
                    textColor: "#8587A4"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.job?.properties?.length || 0) + " Properties", 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              (__props.job?.properties?.length)
                ? (_openBlock(), _createBlock(_component_el_divider, {
                    key: 0,
                    direction: "vertical"
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_14, [
                (getPropertyCategory.value.isResidential)
                  ? (_openBlock(), _createBlock(ResidentialChip, {
                      key: 0,
                      class: "!tw-p-0"
                    }))
                  : _createCommentVNode("", true),
                (getPropertyCategory.value.isCommercial)
                  ? (_openBlock(), _createBlock(CommercialChip, {
                      key: 1,
                      class: "!tw-p-0"
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("p", { innerHTML: projectDescription.value }, null, 8, _hoisted_17)
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["tw-w-full tw-flex tw-flex-col tw-gap-1", {
          'tw-border-t-dashed-custom tw-pt-3 tw-box-border': __props.hasProgressBar,
        }])
        }, [
          (
            props.jobType === 'active' &&
            [
              _unref(ProjectJobStatusEnum).IN_PROGRESS,
              _unref(ProjectJobStatusEnum).COMPLETED,
            ].includes(getProjectStatusElement(__props.job).status)
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                (phaseCount.value)
                  ? (_openBlock(), _createBlock(_component_v_stepper, {
                      key: 0,
                      mobile: "",
                      class: "stepper__wrapper"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_stepper_header, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: _normalizeClass(["stepper__step", {
                  inprogress: phaseCompleted.value === 0,
                  completed: phaseCompleted.value >= 1,
                }])
                            }, [
                              _createVNode(_component_v_stepper_item, {
                                value: "P1",
                                complete: phaseCompleted.value >= 1
                              }, null, 8, ["complete"])
                            ], 2),
                            (phaseCount.value > 1)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass(["stepper__step", {
                  inprogress:
                    phaseCompleted.value <= phaseCount.value - 2 && phaseCompleted.value !== 0,
                  completed: phaseCompleted.value >= phaseCount.value - 1,
                }])
                                }, [
                                  _hoisted_19,
                                  _createVNode(_component_v_stepper_item, {
                                    value: `
                    P${
                      phaseCompleted.value < phaseCount.value - 1
                        ? phaseCompleted.value
                          ? phaseCompleted.value + 1
                          : 2
                        : phaseCount.value - 1
                    }`,
                                    complete: phaseCompleted.value >= phaseCount.value - 1
                                  }, null, 8, ["value", "complete"])
                                ], 2))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", {
                              class: _normalizeClass(["stepper__step", {
                  inprogress:
                    phaseCompleted.value === phaseCount.value - 1 && phaseCompleted.value !== 0,
                  completed: phaseCount.value === phaseCompleted.value,
                }])
                            }, [
                              _hoisted_20,
                              _createVNode(_component_v_stepper_item, {
                                value: "END",
                                complete: phaseCount.value === phaseCompleted.value
                              }, null, 8, ["complete"])
                            ], 2)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_21, [
            (['all', 'draft'].includes(props.jobType || ''))
              ? (_openBlock(), _createElementBlock("div", _hoisted_22))
              : _createCommentVNode("", true),
            (__props.hasProgressBar && props.jobType === 'active')
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(getProjectStatusElement(__props.job).component), {
                  key: 1,
                  class: "tw-flex"
                }))
              : _createCommentVNode("", true),
            _createVNode(ChipState, {
              label: "Details",
              bgColor: "#FAA500",
              textColor: "#FFF",
              class: "!tw-rounded"
            }, {
              postfix: _withCtx(() => [
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_v_icon, {
                    icon: "mdi-chevron-right",
                    color: "#faa500",
                    size: "10px"
                  })
                ])
              ]),
              _: 1
            })
          ])
        ], 2)
      ])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})